import './App.css';
import { BrowserRouter as Router, Route, Routes} from "react-router-dom";
import LandingPage from './pages/LandingPage';
import Register from './pages/Register';
import LogIn from './pages/LogIn';
import Home from "./pages/Home";
import MyChallenges from './pages/MyChallenges';
import Trophies from './pages/Trophies';
import Profile from './pages/Profile';
import Template from './pages/Template';
import EditUser from './pages/Edit';


function App() {
  return (
    <div>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<LogIn />} />
          <Route path="/home" element={<Home />} />
          <Route path="/mychallenges" element={<MyChallenges />} />
          <Route path="/trophies" element={<Trophies />} />
          <Route path="/user/:username" element={<Profile />} />
          <Route path='/user/edit' element={<EditUser /> } />         
          <Route path="/template/:template_id" element={<Template />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
